import { addressBlock } from '../components/address';

import { btnDemo, btnSales, btnTeam } from '../components/cta';
import { icon } from '../components/icons';
import { eyebrow, mesh } from '../components/primitives';
import { intlLine } from '../components/sections';
import { SITE_CONFIG } from '../config/site-config';
import { mailto, routeHref, salesMailto } from '../lib/links';

/* ============================ CONTACT ============================ */
export function pageContact(): string {
  return `
  <section class="hero compact" aria-labelledby="h1">
    ${mesh()}
    <div class="wrap rv">
      ${eyebrow('Contact us')}
      <h1 id="h1">Talk to <span class="grad">ReTax360.</span></h1>
      <p class="lede" style="margin-top:24px">Enterprise evaluations, demos, pricing, security reviews, general questions and careers.</p>
    </div>
  </section>
  <section class="s" style="padding-top:56px" aria-label="Contact options">
    <div class="wrap">
      <div class="team-panel rv">
        <div>${eyebrow('Enterprise team')}<h2 class="h-cap" style="margin-top:14px">Talk with our enterprise team.</h2><p class="muted">Tell us a little about your organization. We can follow up with you, or you can choose an available time right after.</p></div>
        <div class="ctas" style="margin-top:0">${btnTeam('btn-primary')}${btnDemo('Book an Enterprise Demo', 'btn-ghost')}</div>
      </div>
      <ul class="grid3" data-stagger style="margin-top:20px">
        <li class="card rv ccard"><span class="ic-tile">${icon('building')}</span><h2 class="h-card">Enterprise Sales</h2><p>Enterprise evaluations, demos, deployment discussions and pricing.</p><p class="fine">Prefer email? <a class="ul" href="${salesMailto()}">${SITE_CONFIG.SALES_EMAIL}</a></p><div class="cbtns">${btnSales('btn-primary btn-sm')}</div></li>
        <li class="card rv ccard"><span class="ic-tile">${icon('mail')}</span><h2 class="h-card">General &amp; Careers</h2><p><a class="ul" href="${mailto(SITE_CONFIG.INFO_EMAIL)}">${SITE_CONFIG.INFO_EMAIL}</a></p><p>General questions, partnerships and careers.</p><div class="cbtns"><a class="btn btn-primary btn-sm" href="${mailto(SITE_CONFIG.INFO_EMAIL)}">Email Us</a><a class="btn btn-ghost btn-sm" href="${routeHref('/careers')}">Careers</a></div></li>
        <li class="card rv ccard"><span class="ic-tile">${icon('pin')}</span><h2 class="h-card">Address</h2>${addressBlock()}<p class="legal-links" style="margin-top:auto;padding-top:14px"><a class="ul" href="${routeHref('/privacy')}">Privacy Policy</a> · <a class="ul" href="${routeHref('/terms')}">Terms of Service</a></p></li>
      </ul>
      <div style="margin-top:32px">${intlLine()}</div>
    </div>
  </section>`;
}
